import {
  checkSubscriptionResource,
  hasUserSubscriptedIdealPlan,
} from 'common/subscription/checkSubscriptionResource';
import { Divider } from 'design-system/components/Divider';
import Icon from 'design-system/components/Icon/Icon';
import { ComponentPropsWithoutRef, useContext } from 'react';
import { CollectionDetailContext } from 'state/collection/CollectionDetailProvider';
import { twMerge } from 'tailwind-merge';
import LibraryMaterialDetailReadySection from '../components/LibraryMaterialDetailReadySection';
import LibraryMaterialDetailUpgradePlanSection from '../components/LibraryMaterialDetailUpgradePlanSection';
import CollectionDetailMainSection from './components/CollectionDetailMainSection';
import CollectionDetailOwnerStatusInteraction from './components/CollectionDetailOwnerStatusInteraction';

type CollectionDetailSideBarProps = ComponentPropsWithoutRef<'div'> & {};

const CollectionDetailSideBar = (props: CollectionDetailSideBarProps) => {
  const { className, ...restProps } = props;
  const { collection, latestSubscription } = useContext(
    CollectionDetailContext
  );

  const hasUserSubscriptedIdealPlanValue =
    hasUserSubscriptedIdealPlan(latestSubscription) || collection?.isOwner;

  const readySection = (
    <LibraryMaterialDetailReadySection
      mainTitle="Bộ sưu tập đã sẵn sàng"
      subTitle="Xem bộ sưu tập ngay thôi !"
      icon={<Icon iconName={'done'} size={32} />}
    />
  );

  return (
    <div
      {...restProps}
      className="sticky left-0 top-[70px] mt-6 h-fit flex-shrink-0"
    >
      {collection?.isOwner ? (
        <CollectionDetailOwnerStatusInteraction
          fallbackElement={readySection}
        />
      ) : checkSubscriptionResource(latestSubscription).collection
          .accessToCollection ? (
        readySection
      ) : null}

      <div
        style={{
          background: !hasUserSubscriptedIdealPlanValue
            ? 'linear-gradient(180deg, #FFF 0%, #FFF9E9 100%)'
            : '',
        }}
        className={twMerge(
          'mt-4 flex h-fit w-[350px] flex-col gap-6 rounded-lg border  bg-white p-6 shadow-elevator2',
          hasUserSubscriptedIdealPlanValue
            ? 'border-Success/Border'
            : 'border-Other/OutlinedUpgradedborder-stroke',
          className
        )}
      >
        {!hasUserSubscriptedIdealPlanValue && (
          <>
            <LibraryMaterialDetailUpgradePlanSection
              mainTitle="Bộ sưu tập Premium"
              subtTitle="Nâng cấp thành viên ngay"
            />
            <Divider />
          </>
        )}
        <CollectionDetailMainSection />
      </div>
    </div>
  );
};

export default CollectionDetailSideBar;
